import { __extends, __values } from 'tslib';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, Component, NgModule, InjectionToken, SkipSelf, Optional, defineInjectable, inject, Inject } from '@angular/core';

/**
 * @fileoverview added by tsickle
 * Generated from: lib/msgm-api-lib-configurations.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var MsgmLibConfiguration = /** @class */ (function () {
    function MsgmLibConfiguration() {
    }
    return MsgmLibConfiguration;
}());
/**
 * @abstract
 */
var MsgmConfigurationProvider = /** @class */ (function () {
    function MsgmConfigurationProvider() {
    }
    MsgmConfigurationProvider.decorators = [
        { type: Injectable, args: [{ providedIn: 'root' },] }
    ];
    /** @nocollapse */ MsgmConfigurationProvider.ngInjectableDef = defineInjectable({ factory: function MsgmConfigurationProvider_Factory() { return new MsgmConfigurationProvider(); }, token: MsgmConfigurationProvider, providedIn: "root" });
    return MsgmConfigurationProvider;
}());
var DefaultMsgmConfiguration = /** @class */ (function (_super) {
    __extends(DefaultMsgmConfiguration, _super);
    function DefaultMsgmConfiguration() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(DefaultMsgmConfiguration.prototype, "config", {
        get: /**
         * @return {?}
         */
        function () {
            return {
                apiConfig: {
                    basePathMsgm: 'https://igate.beook.work/msgm/v1',
                    authorizationSessionStorageKey: 'authorization'
                }
            };
        },
        enumerable: true,
        configurable: true
    });
    DefaultMsgmConfiguration.decorators = [
        { type: Injectable, args: [{ providedIn: 'root' },] }
    ];
    /** @nocollapse */ DefaultMsgmConfiguration.ngInjectableDef = defineInjectable({ factory: function DefaultMsgmConfiguration_Factory() { return new DefaultMsgmConfiguration(); }, token: DefaultMsgmConfiguration, providedIn: "root" });
    return DefaultMsgmConfiguration;
}(MsgmConfigurationProvider));
var MsgmConfiguration = /** @class */ (function () {
    function MsgmConfiguration() {
    }
    return MsgmConfiguration;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/msgm_angular-client/variables.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var BASE_PATH = new InjectionToken('basePath');
/** @type {?} */
var COLLECTION_FORMATS = {
    'csv': ',',
    'tsv': '   ',
    'ssv': ' ',
    'pipes': '|'
};

/**
 * @fileoverview added by tsickle
 * Generated from: lib/msgm_angular-client/configuration.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var Configuration = /** @class */ (function () {
    function Configuration(configurationParameters) {
        if (configurationParameters === void 0) { configurationParameters = {}; }
        this.apiKeys = configurationParameters.apiKeys;
        this.username = configurationParameters.username;
        this.password = configurationParameters.password;
        this.accessToken = configurationParameters.accessToken;
        this.basePath = configurationParameters.basePath;
        this.withCredentials = configurationParameters.withCredentials;
    }
    /**
     * Select the correct content-type to use for a request.
     * Uses {@link Configuration#isJsonMime} to determine the correct content-type.
     * If no content type is found return the first found type if the contentTypes is not empty
     * @param contentTypes - the array of content types that are available for selection
     * @returns the selected content-type or <code>undefined</code> if no selection could be made.
     */
    /**
     * Select the correct content-type to use for a request.
     * Uses {\@link Configuration#isJsonMime} to determine the correct content-type.
     * If no content type is found return the first found type if the contentTypes is not empty
     * @param {?} contentTypes - the array of content types that are available for selection
     * @return {?} the selected content-type or <code>undefined</code> if no selection could be made.
     */
    Configuration.prototype.selectHeaderContentType = /**
     * Select the correct content-type to use for a request.
     * Uses {\@link Configuration#isJsonMime} to determine the correct content-type.
     * If no content type is found return the first found type if the contentTypes is not empty
     * @param {?} contentTypes - the array of content types that are available for selection
     * @return {?} the selected content-type or <code>undefined</code> if no selection could be made.
     */
    function (contentTypes) {
        var _this = this;
        if (contentTypes.length == 0) {
            return undefined;
        }
        /** @type {?} */
        var type = contentTypes.find((/**
         * @param {?} x
         * @return {?}
         */
        function (x) { return _this.isJsonMime(x); }));
        if (type === undefined) {
            return contentTypes[0];
        }
        return type;
    };
    /**
     * Select the correct accept content-type to use for a request.
     * Uses {@link Configuration#isJsonMime} to determine the correct accept content-type.
     * If no content type is found return the first found type if the contentTypes is not empty
     * @param accepts - the array of content types that are available for selection.
     * @returns the selected content-type or <code>undefined</code> if no selection could be made.
     */
    /**
     * Select the correct accept content-type to use for a request.
     * Uses {\@link Configuration#isJsonMime} to determine the correct accept content-type.
     * If no content type is found return the first found type if the contentTypes is not empty
     * @param {?} accepts - the array of content types that are available for selection.
     * @return {?} the selected content-type or <code>undefined</code> if no selection could be made.
     */
    Configuration.prototype.selectHeaderAccept = /**
     * Select the correct accept content-type to use for a request.
     * Uses {\@link Configuration#isJsonMime} to determine the correct accept content-type.
     * If no content type is found return the first found type if the contentTypes is not empty
     * @param {?} accepts - the array of content types that are available for selection.
     * @return {?} the selected content-type or <code>undefined</code> if no selection could be made.
     */
    function (accepts) {
        var _this = this;
        if (accepts.length == 0) {
            return undefined;
        }
        /** @type {?} */
        var type = accepts.find((/**
         * @param {?} x
         * @return {?}
         */
        function (x) { return _this.isJsonMime(x); }));
        if (type === undefined) {
            return accepts[0];
        }
        return type;
    };
    /**
     * Check if the given MIME is a JSON MIME.
     * JSON MIME examples:
     *   application/json
     *   application/json; charset=UTF8
     *   APPLICATION/JSON
     *   application/vnd.company+json
     * @param mime - MIME (Multipurpose Internet Mail Extensions)
     * @return True if the given MIME is JSON, false otherwise.
     */
    /**
     * Check if the given MIME is a JSON MIME.
     * JSON MIME examples:
     *   application/json
     *   application/json; charset=UTF8
     *   APPLICATION/JSON
     *   application/vnd.company+json
     * @param {?} mime - MIME (Multipurpose Internet Mail Extensions)
     * @return {?} True if the given MIME is JSON, false otherwise.
     */
    Configuration.prototype.isJsonMime = /**
     * Check if the given MIME is a JSON MIME.
     * JSON MIME examples:
     *   application/json
     *   application/json; charset=UTF8
     *   APPLICATION/JSON
     *   application/vnd.company+json
     * @param {?} mime - MIME (Multipurpose Internet Mail Extensions)
     * @return {?} True if the given MIME is JSON, false otherwise.
     */
    function (mime) {
        /** @type {?} */
        var jsonMime = new RegExp('^(application\/json|[^;/ \t]+\/[^;/ \t]+[+]json)[ \t]*(;.*)?$', 'i');
        return mime != null && (jsonMime.test(mime) || mime.toLowerCase() === 'application/json-patch+json');
    };
    return Configuration;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/msgm_angular-client/api/mSGMClient1.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var MSGMClient1Service = /** @class */ (function () {
    function MSGMClient1Service(httpClient, basePath, configuration) {
        this.httpClient = httpClient;
        this.basePath = 'https://igate.beook.work/msgm/v1';
        this.defaultHeaders = new HttpHeaders();
        this.configuration = new Configuration();
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }
    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    /**
     * @private
     * @param {?} consumes string[] mime-types
     * @return {?} true: consumes contains 'multipart/form-data', false: otherwise
     */
    MSGMClient1Service.prototype.canConsumeForm = /**
     * @private
     * @param {?} consumes string[] mime-types
     * @return {?} true: consumes contains 'multipart/form-data', false: otherwise
     */
    function (consumes) {
        var e_1, _a;
        /** @type {?} */
        var form = 'multipart/form-data';
        try {
            for (var consumes_1 = __values(consumes), consumes_1_1 = consumes_1.next(); !consumes_1_1.done; consumes_1_1 = consumes_1.next()) {
                var consume = consumes_1_1.value;
                if (form === consume) {
                    return true;
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (consumes_1_1 && !consumes_1_1.done && (_a = consumes_1.return)) _a.call(consumes_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return false;
    };
    /**
     * @param {?} X_Ia_Correlation_Id
     * @param {?} X_Ia_Subject
     * @param {?} X_Ia_Roles
     * @param {?} DestinationCreateRequest1
     * @param {?=} observe
     * @param {?=} reportProgress
     * @return {?}
     */
    MSGMClient1Service.prototype.createDestination = /**
     * @param {?} X_Ia_Correlation_Id
     * @param {?} X_Ia_Subject
     * @param {?} X_Ia_Roles
     * @param {?} DestinationCreateRequest1
     * @param {?=} observe
     * @param {?=} reportProgress
     * @return {?}
     */
    function (X_Ia_Correlation_Id, X_Ia_Subject, X_Ia_Roles, DestinationCreateRequest1, observe, reportProgress) {
        if (observe === void 0) { observe = 'body'; }
        if (reportProgress === void 0) { reportProgress = false; }
        if (X_Ia_Correlation_Id === null || X_Ia_Correlation_Id === undefined) {
            throw new Error('Required parameter X_Ia_Correlation_Id was null or undefined when calling createDestination.');
        }
        if (X_Ia_Subject === null || X_Ia_Subject === undefined) {
            throw new Error('Required parameter X_Ia_Subject was null or undefined when calling createDestination.');
        }
        if (X_Ia_Roles === null || X_Ia_Roles === undefined) {
            throw new Error('Required parameter X_Ia_Roles was null or undefined when calling createDestination.');
        }
        if (DestinationCreateRequest1 === null || DestinationCreateRequest1 === undefined) {
            throw new Error('Required parameter DestinationCreateRequest1 was null or undefined when calling createDestination.');
        }
        /** @type {?} */
        var headers = this.defaultHeaders;
        if (X_Ia_Correlation_Id !== undefined && X_Ia_Correlation_Id !== null) {
            headers = headers.set('X-Ia-Correlation-Id', String(X_Ia_Correlation_Id));
        }
        if (X_Ia_Subject !== undefined && X_Ia_Subject !== null) {
            headers = headers.set('X-Ia-Subject', String(X_Ia_Subject));
        }
        if (X_Ia_Roles !== undefined && X_Ia_Roles !== null) {
            headers = headers.set('X-Ia-Roles', String(X_Ia_Roles));
        }
        // authentication (AuthorizationHeader) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }
        // to determine the Accept header
        /** @type {?} */
        var httpHeaderAccepts = [
            'application/json'
        ];
        /** @type {?} */
        var httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        /** @type {?} */
        var consumes = [
            'application/json'
        ];
        /** @type {?} */
        var httpContentTypeSelected = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }
        return this.httpClient.post(this.basePath + "/destination/create", DestinationCreateRequest1, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress
        });
    };
    /**
     * @param {?} X_Ia_Correlation_Id
     * @param {?} X_Ia_Subject
     * @param {?} X_Ia_Roles
     * @param {?} UserCreateRequest1
     * @param {?=} observe
     * @param {?=} reportProgress
     * @return {?}
     */
    MSGMClient1Service.prototype.createUser = /**
     * @param {?} X_Ia_Correlation_Id
     * @param {?} X_Ia_Subject
     * @param {?} X_Ia_Roles
     * @param {?} UserCreateRequest1
     * @param {?=} observe
     * @param {?=} reportProgress
     * @return {?}
     */
    function (X_Ia_Correlation_Id, X_Ia_Subject, X_Ia_Roles, UserCreateRequest1, observe, reportProgress) {
        if (observe === void 0) { observe = 'body'; }
        if (reportProgress === void 0) { reportProgress = false; }
        if (X_Ia_Correlation_Id === null || X_Ia_Correlation_Id === undefined) {
            throw new Error('Required parameter X_Ia_Correlation_Id was null or undefined when calling createUser.');
        }
        if (X_Ia_Subject === null || X_Ia_Subject === undefined) {
            throw new Error('Required parameter X_Ia_Subject was null or undefined when calling createUser.');
        }
        if (X_Ia_Roles === null || X_Ia_Roles === undefined) {
            throw new Error('Required parameter X_Ia_Roles was null or undefined when calling createUser.');
        }
        if (UserCreateRequest1 === null || UserCreateRequest1 === undefined) {
            throw new Error('Required parameter UserCreateRequest1 was null or undefined when calling createUser.');
        }
        /** @type {?} */
        var headers = this.defaultHeaders;
        if (X_Ia_Correlation_Id !== undefined && X_Ia_Correlation_Id !== null) {
            headers = headers.set('X-Ia-Correlation-Id', String(X_Ia_Correlation_Id));
        }
        if (X_Ia_Subject !== undefined && X_Ia_Subject !== null) {
            headers = headers.set('X-Ia-Subject', String(X_Ia_Subject));
        }
        if (X_Ia_Roles !== undefined && X_Ia_Roles !== null) {
            headers = headers.set('X-Ia-Roles', String(X_Ia_Roles));
        }
        // authentication (AuthorizationHeader) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }
        // to determine the Accept header
        /** @type {?} */
        var httpHeaderAccepts = [
            'application/json'
        ];
        /** @type {?} */
        var httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        /** @type {?} */
        var consumes = [
            'application/json'
        ];
        /** @type {?} */
        var httpContentTypeSelected = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }
        return this.httpClient.post(this.basePath + "/user/create", UserCreateRequest1, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress
        });
    };
    /**
     * @param {?} X_Ia_Correlation_Id
     * @param {?} X_Ia_Subject
     * @param {?} X_Ia_Roles
     * @param {?} MessageDeleteRequest1
     * @param {?=} observe
     * @param {?=} reportProgress
     * @return {?}
     */
    MSGMClient1Service.prototype.deleteMessage = /**
     * @param {?} X_Ia_Correlation_Id
     * @param {?} X_Ia_Subject
     * @param {?} X_Ia_Roles
     * @param {?} MessageDeleteRequest1
     * @param {?=} observe
     * @param {?=} reportProgress
     * @return {?}
     */
    function (X_Ia_Correlation_Id, X_Ia_Subject, X_Ia_Roles, MessageDeleteRequest1, observe, reportProgress) {
        if (observe === void 0) { observe = 'body'; }
        if (reportProgress === void 0) { reportProgress = false; }
        if (X_Ia_Correlation_Id === null || X_Ia_Correlation_Id === undefined) {
            throw new Error('Required parameter X_Ia_Correlation_Id was null or undefined when calling deleteMessage.');
        }
        if (X_Ia_Subject === null || X_Ia_Subject === undefined) {
            throw new Error('Required parameter X_Ia_Subject was null or undefined when calling deleteMessage.');
        }
        if (X_Ia_Roles === null || X_Ia_Roles === undefined) {
            throw new Error('Required parameter X_Ia_Roles was null or undefined when calling deleteMessage.');
        }
        if (MessageDeleteRequest1 === null || MessageDeleteRequest1 === undefined) {
            throw new Error('Required parameter MessageDeleteRequest1 was null or undefined when calling deleteMessage.');
        }
        /** @type {?} */
        var headers = this.defaultHeaders;
        if (X_Ia_Correlation_Id !== undefined && X_Ia_Correlation_Id !== null) {
            headers = headers.set('X-Ia-Correlation-Id', String(X_Ia_Correlation_Id));
        }
        if (X_Ia_Subject !== undefined && X_Ia_Subject !== null) {
            headers = headers.set('X-Ia-Subject', String(X_Ia_Subject));
        }
        if (X_Ia_Roles !== undefined && X_Ia_Roles !== null) {
            headers = headers.set('X-Ia-Roles', String(X_Ia_Roles));
        }
        // authentication (AuthorizationHeader) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }
        // to determine the Accept header
        /** @type {?} */
        var httpHeaderAccepts = [
            'application/json'
        ];
        /** @type {?} */
        var httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        /** @type {?} */
        var consumes = [
            'application/json'
        ];
        /** @type {?} */
        var httpContentTypeSelected = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }
        return this.httpClient.post(this.basePath + "/message/delete", MessageDeleteRequest1, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress
        });
    };
    /**
     * @param {?} X_Ia_Correlation_Id
     * @param {?} X_Ia_Subject
     * @param {?} X_Ia_Roles
     * @param {?} DestinationDiscoverRequest1
     * @param {?=} observe
     * @param {?=} reportProgress
     * @return {?}
     */
    MSGMClient1Service.prototype.discoverDestination = /**
     * @param {?} X_Ia_Correlation_Id
     * @param {?} X_Ia_Subject
     * @param {?} X_Ia_Roles
     * @param {?} DestinationDiscoverRequest1
     * @param {?=} observe
     * @param {?=} reportProgress
     * @return {?}
     */
    function (X_Ia_Correlation_Id, X_Ia_Subject, X_Ia_Roles, DestinationDiscoverRequest1, observe, reportProgress) {
        if (observe === void 0) { observe = 'body'; }
        if (reportProgress === void 0) { reportProgress = false; }
        if (X_Ia_Correlation_Id === null || X_Ia_Correlation_Id === undefined) {
            throw new Error('Required parameter X_Ia_Correlation_Id was null or undefined when calling discoverDestination.');
        }
        if (X_Ia_Subject === null || X_Ia_Subject === undefined) {
            throw new Error('Required parameter X_Ia_Subject was null or undefined when calling discoverDestination.');
        }
        if (X_Ia_Roles === null || X_Ia_Roles === undefined) {
            throw new Error('Required parameter X_Ia_Roles was null or undefined when calling discoverDestination.');
        }
        if (DestinationDiscoverRequest1 === null || DestinationDiscoverRequest1 === undefined) {
            throw new Error('Required parameter DestinationDiscoverRequest1 was null or undefined when calling discoverDestination.');
        }
        /** @type {?} */
        var headers = this.defaultHeaders;
        if (X_Ia_Correlation_Id !== undefined && X_Ia_Correlation_Id !== null) {
            headers = headers.set('X-Ia-Correlation-Id', String(X_Ia_Correlation_Id));
        }
        if (X_Ia_Subject !== undefined && X_Ia_Subject !== null) {
            headers = headers.set('X-Ia-Subject', String(X_Ia_Subject));
        }
        if (X_Ia_Roles !== undefined && X_Ia_Roles !== null) {
            headers = headers.set('X-Ia-Roles', String(X_Ia_Roles));
        }
        // authentication (AuthorizationHeader) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }
        // to determine the Accept header
        /** @type {?} */
        var httpHeaderAccepts = [
            'application/json'
        ];
        /** @type {?} */
        var httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        /** @type {?} */
        var consumes = [
            'application/json'
        ];
        /** @type {?} */
        var httpContentTypeSelected = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }
        return this.httpClient.post(this.basePath + "/destination/discover", DestinationDiscoverRequest1, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress
        });
    };
    /**
     * @param {?} X_Ia_Correlation_Id
     * @param {?} X_Ia_Subject
     * @param {?} X_Ia_Roles
     * @param {?} MessageEditRequest1
     * @param {?=} observe
     * @param {?=} reportProgress
     * @return {?}
     */
    MSGMClient1Service.prototype.editMessage = /**
     * @param {?} X_Ia_Correlation_Id
     * @param {?} X_Ia_Subject
     * @param {?} X_Ia_Roles
     * @param {?} MessageEditRequest1
     * @param {?=} observe
     * @param {?=} reportProgress
     * @return {?}
     */
    function (X_Ia_Correlation_Id, X_Ia_Subject, X_Ia_Roles, MessageEditRequest1, observe, reportProgress) {
        if (observe === void 0) { observe = 'body'; }
        if (reportProgress === void 0) { reportProgress = false; }
        if (X_Ia_Correlation_Id === null || X_Ia_Correlation_Id === undefined) {
            throw new Error('Required parameter X_Ia_Correlation_Id was null or undefined when calling editMessage.');
        }
        if (X_Ia_Subject === null || X_Ia_Subject === undefined) {
            throw new Error('Required parameter X_Ia_Subject was null or undefined when calling editMessage.');
        }
        if (X_Ia_Roles === null || X_Ia_Roles === undefined) {
            throw new Error('Required parameter X_Ia_Roles was null or undefined when calling editMessage.');
        }
        if (MessageEditRequest1 === null || MessageEditRequest1 === undefined) {
            throw new Error('Required parameter MessageEditRequest1 was null or undefined when calling editMessage.');
        }
        /** @type {?} */
        var headers = this.defaultHeaders;
        if (X_Ia_Correlation_Id !== undefined && X_Ia_Correlation_Id !== null) {
            headers = headers.set('X-Ia-Correlation-Id', String(X_Ia_Correlation_Id));
        }
        if (X_Ia_Subject !== undefined && X_Ia_Subject !== null) {
            headers = headers.set('X-Ia-Subject', String(X_Ia_Subject));
        }
        if (X_Ia_Roles !== undefined && X_Ia_Roles !== null) {
            headers = headers.set('X-Ia-Roles', String(X_Ia_Roles));
        }
        // authentication (AuthorizationHeader) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }
        // to determine the Accept header
        /** @type {?} */
        var httpHeaderAccepts = [
            'application/json'
        ];
        /** @type {?} */
        var httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        /** @type {?} */
        var consumes = [
            'application/json'
        ];
        /** @type {?} */
        var httpContentTypeSelected = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }
        return this.httpClient.post(this.basePath + "/message/edit", MessageEditRequest1, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress
        });
    };
    /**
     * @param {?} X_Ia_Correlation_Id
     * @param {?} X_Ia_Subject
     * @param {?} X_Ia_Roles
     * @param {?} DestinationGetRequest1
     * @param {?=} observe
     * @param {?=} reportProgress
     * @return {?}
     */
    MSGMClient1Service.prototype.getDestination = /**
     * @param {?} X_Ia_Correlation_Id
     * @param {?} X_Ia_Subject
     * @param {?} X_Ia_Roles
     * @param {?} DestinationGetRequest1
     * @param {?=} observe
     * @param {?=} reportProgress
     * @return {?}
     */
    function (X_Ia_Correlation_Id, X_Ia_Subject, X_Ia_Roles, DestinationGetRequest1, observe, reportProgress) {
        if (observe === void 0) { observe = 'body'; }
        if (reportProgress === void 0) { reportProgress = false; }
        if (X_Ia_Correlation_Id === null || X_Ia_Correlation_Id === undefined) {
            throw new Error('Required parameter X_Ia_Correlation_Id was null or undefined when calling getDestination.');
        }
        if (X_Ia_Subject === null || X_Ia_Subject === undefined) {
            throw new Error('Required parameter X_Ia_Subject was null or undefined when calling getDestination.');
        }
        if (X_Ia_Roles === null || X_Ia_Roles === undefined) {
            throw new Error('Required parameter X_Ia_Roles was null or undefined when calling getDestination.');
        }
        if (DestinationGetRequest1 === null || DestinationGetRequest1 === undefined) {
            throw new Error('Required parameter DestinationGetRequest1 was null or undefined when calling getDestination.');
        }
        /** @type {?} */
        var headers = this.defaultHeaders;
        if (X_Ia_Correlation_Id !== undefined && X_Ia_Correlation_Id !== null) {
            headers = headers.set('X-Ia-Correlation-Id', String(X_Ia_Correlation_Id));
        }
        if (X_Ia_Subject !== undefined && X_Ia_Subject !== null) {
            headers = headers.set('X-Ia-Subject', String(X_Ia_Subject));
        }
        if (X_Ia_Roles !== undefined && X_Ia_Roles !== null) {
            headers = headers.set('X-Ia-Roles', String(X_Ia_Roles));
        }
        // authentication (AuthorizationHeader) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }
        // to determine the Accept header
        /** @type {?} */
        var httpHeaderAccepts = [
            'application/json'
        ];
        /** @type {?} */
        var httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        /** @type {?} */
        var consumes = [
            'application/json'
        ];
        /** @type {?} */
        var httpContentTypeSelected = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }
        return this.httpClient.post(this.basePath + "/destination/get", DestinationGetRequest1, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress
        });
    };
    /**
     * @param {?} X_Ia_Correlation_Id
     * @param {?} X_Ia_Subject
     * @param {?} X_Ia_Roles
     * @param {?} MessageGetRequest1
     * @param {?=} observe
     * @param {?=} reportProgress
     * @return {?}
     */
    MSGMClient1Service.prototype.getMessage = /**
     * @param {?} X_Ia_Correlation_Id
     * @param {?} X_Ia_Subject
     * @param {?} X_Ia_Roles
     * @param {?} MessageGetRequest1
     * @param {?=} observe
     * @param {?=} reportProgress
     * @return {?}
     */
    function (X_Ia_Correlation_Id, X_Ia_Subject, X_Ia_Roles, MessageGetRequest1, observe, reportProgress) {
        if (observe === void 0) { observe = 'body'; }
        if (reportProgress === void 0) { reportProgress = false; }
        if (X_Ia_Correlation_Id === null || X_Ia_Correlation_Id === undefined) {
            throw new Error('Required parameter X_Ia_Correlation_Id was null or undefined when calling getMessage.');
        }
        if (X_Ia_Subject === null || X_Ia_Subject === undefined) {
            throw new Error('Required parameter X_Ia_Subject was null or undefined when calling getMessage.');
        }
        if (X_Ia_Roles === null || X_Ia_Roles === undefined) {
            throw new Error('Required parameter X_Ia_Roles was null or undefined when calling getMessage.');
        }
        if (MessageGetRequest1 === null || MessageGetRequest1 === undefined) {
            throw new Error('Required parameter MessageGetRequest1 was null or undefined when calling getMessage.');
        }
        /** @type {?} */
        var headers = this.defaultHeaders;
        if (X_Ia_Correlation_Id !== undefined && X_Ia_Correlation_Id !== null) {
            headers = headers.set('X-Ia-Correlation-Id', String(X_Ia_Correlation_Id));
        }
        if (X_Ia_Subject !== undefined && X_Ia_Subject !== null) {
            headers = headers.set('X-Ia-Subject', String(X_Ia_Subject));
        }
        if (X_Ia_Roles !== undefined && X_Ia_Roles !== null) {
            headers = headers.set('X-Ia-Roles', String(X_Ia_Roles));
        }
        // authentication (AuthorizationHeader) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }
        // to determine the Accept header
        /** @type {?} */
        var httpHeaderAccepts = [
            'application/json'
        ];
        /** @type {?} */
        var httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        /** @type {?} */
        var consumes = [
            'application/json'
        ];
        /** @type {?} */
        var httpContentTypeSelected = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }
        return this.httpClient.post(this.basePath + "/message/get", MessageGetRequest1, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress
        });
    };
    /**
     * @param {?} X_Ia_Correlation_Id
     * @param {?} X_Ia_Subject
     * @param {?} X_Ia_Roles
     * @param {?} UserGetRequest1
     * @param {?=} observe
     * @param {?=} reportProgress
     * @return {?}
     */
    MSGMClient1Service.prototype.getUser = /**
     * @param {?} X_Ia_Correlation_Id
     * @param {?} X_Ia_Subject
     * @param {?} X_Ia_Roles
     * @param {?} UserGetRequest1
     * @param {?=} observe
     * @param {?=} reportProgress
     * @return {?}
     */
    function (X_Ia_Correlation_Id, X_Ia_Subject, X_Ia_Roles, UserGetRequest1, observe, reportProgress) {
        if (observe === void 0) { observe = 'body'; }
        if (reportProgress === void 0) { reportProgress = false; }
        if (X_Ia_Correlation_Id === null || X_Ia_Correlation_Id === undefined) {
            throw new Error('Required parameter X_Ia_Correlation_Id was null or undefined when calling getUser.');
        }
        if (X_Ia_Subject === null || X_Ia_Subject === undefined) {
            throw new Error('Required parameter X_Ia_Subject was null or undefined when calling getUser.');
        }
        if (X_Ia_Roles === null || X_Ia_Roles === undefined) {
            throw new Error('Required parameter X_Ia_Roles was null or undefined when calling getUser.');
        }
        if (UserGetRequest1 === null || UserGetRequest1 === undefined) {
            throw new Error('Required parameter UserGetRequest1 was null or undefined when calling getUser.');
        }
        /** @type {?} */
        var headers = this.defaultHeaders;
        if (X_Ia_Correlation_Id !== undefined && X_Ia_Correlation_Id !== null) {
            headers = headers.set('X-Ia-Correlation-Id', String(X_Ia_Correlation_Id));
        }
        if (X_Ia_Subject !== undefined && X_Ia_Subject !== null) {
            headers = headers.set('X-Ia-Subject', String(X_Ia_Subject));
        }
        if (X_Ia_Roles !== undefined && X_Ia_Roles !== null) {
            headers = headers.set('X-Ia-Roles', String(X_Ia_Roles));
        }
        // authentication (AuthorizationHeader) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }
        // to determine the Accept header
        /** @type {?} */
        var httpHeaderAccepts = [
            'application/json'
        ];
        /** @type {?} */
        var httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        /** @type {?} */
        var consumes = [
            'application/json'
        ];
        /** @type {?} */
        var httpContentTypeSelected = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }
        return this.httpClient.post(this.basePath + "/user/get", UserGetRequest1, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress
        });
    };
    /**
     * @param {?} X_Ia_Correlation_Id
     * @param {?} X_Ia_Subject
     * @param {?} X_Ia_Roles
     * @param {?} DestinationListRequest1
     * @param {?=} observe
     * @param {?=} reportProgress
     * @return {?}
     */
    MSGMClient1Service.prototype.listDestinations = /**
     * @param {?} X_Ia_Correlation_Id
     * @param {?} X_Ia_Subject
     * @param {?} X_Ia_Roles
     * @param {?} DestinationListRequest1
     * @param {?=} observe
     * @param {?=} reportProgress
     * @return {?}
     */
    function (X_Ia_Correlation_Id, X_Ia_Subject, X_Ia_Roles, DestinationListRequest1, observe, reportProgress) {
        if (observe === void 0) { observe = 'body'; }
        if (reportProgress === void 0) { reportProgress = false; }
        if (X_Ia_Correlation_Id === null || X_Ia_Correlation_Id === undefined) {
            throw new Error('Required parameter X_Ia_Correlation_Id was null or undefined when calling listDestinations.');
        }
        if (X_Ia_Subject === null || X_Ia_Subject === undefined) {
            throw new Error('Required parameter X_Ia_Subject was null or undefined when calling listDestinations.');
        }
        if (X_Ia_Roles === null || X_Ia_Roles === undefined) {
            throw new Error('Required parameter X_Ia_Roles was null or undefined when calling listDestinations.');
        }
        if (DestinationListRequest1 === null || DestinationListRequest1 === undefined) {
            throw new Error('Required parameter DestinationListRequest1 was null or undefined when calling listDestinations.');
        }
        /** @type {?} */
        var headers = this.defaultHeaders;
        if (X_Ia_Correlation_Id !== undefined && X_Ia_Correlation_Id !== null) {
            headers = headers.set('X-Ia-Correlation-Id', String(X_Ia_Correlation_Id));
        }
        if (X_Ia_Subject !== undefined && X_Ia_Subject !== null) {
            headers = headers.set('X-Ia-Subject', String(X_Ia_Subject));
        }
        if (X_Ia_Roles !== undefined && X_Ia_Roles !== null) {
            headers = headers.set('X-Ia-Roles', String(X_Ia_Roles));
        }
        // authentication (AuthorizationHeader) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }
        // to determine the Accept header
        /** @type {?} */
        var httpHeaderAccepts = [
            'application/json'
        ];
        /** @type {?} */
        var httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        /** @type {?} */
        var consumes = [
            'application/json'
        ];
        /** @type {?} */
        var httpContentTypeSelected = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }
        return this.httpClient.post(this.basePath + "/destination/list", DestinationListRequest1, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress
        });
    };
    /**
     * @param {?} X_Ia_Correlation_Id
     * @param {?} X_Ia_Subject
     * @param {?} X_Ia_Roles
     * @param {?} MessageListRequest1
     * @param {?=} observe
     * @param {?=} reportProgress
     * @return {?}
     */
    MSGMClient1Service.prototype.listMessages = /**
     * @param {?} X_Ia_Correlation_Id
     * @param {?} X_Ia_Subject
     * @param {?} X_Ia_Roles
     * @param {?} MessageListRequest1
     * @param {?=} observe
     * @param {?=} reportProgress
     * @return {?}
     */
    function (X_Ia_Correlation_Id, X_Ia_Subject, X_Ia_Roles, MessageListRequest1, observe, reportProgress) {
        if (observe === void 0) { observe = 'body'; }
        if (reportProgress === void 0) { reportProgress = false; }
        if (X_Ia_Correlation_Id === null || X_Ia_Correlation_Id === undefined) {
            throw new Error('Required parameter X_Ia_Correlation_Id was null or undefined when calling listMessages.');
        }
        if (X_Ia_Subject === null || X_Ia_Subject === undefined) {
            throw new Error('Required parameter X_Ia_Subject was null or undefined when calling listMessages.');
        }
        if (X_Ia_Roles === null || X_Ia_Roles === undefined) {
            throw new Error('Required parameter X_Ia_Roles was null or undefined when calling listMessages.');
        }
        if (MessageListRequest1 === null || MessageListRequest1 === undefined) {
            throw new Error('Required parameter MessageListRequest1 was null or undefined when calling listMessages.');
        }
        /** @type {?} */
        var headers = this.defaultHeaders;
        if (X_Ia_Correlation_Id !== undefined && X_Ia_Correlation_Id !== null) {
            headers = headers.set('X-Ia-Correlation-Id', String(X_Ia_Correlation_Id));
        }
        if (X_Ia_Subject !== undefined && X_Ia_Subject !== null) {
            headers = headers.set('X-Ia-Subject', String(X_Ia_Subject));
        }
        if (X_Ia_Roles !== undefined && X_Ia_Roles !== null) {
            headers = headers.set('X-Ia-Roles', String(X_Ia_Roles));
        }
        // authentication (AuthorizationHeader) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }
        // to determine the Accept header
        /** @type {?} */
        var httpHeaderAccepts = [
            'application/json'
        ];
        /** @type {?} */
        var httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        /** @type {?} */
        var consumes = [
            'application/json'
        ];
        /** @type {?} */
        var httpContentTypeSelected = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }
        return this.httpClient.post(this.basePath + "/message/list", MessageListRequest1, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress
        });
    };
    /**
     * @param {?} X_Ia_Correlation_Id
     * @param {?} X_Ia_Subject
     * @param {?} X_Ia_Roles
     * @param {?} MessageCreateRequest1
     * @param {?=} observe
     * @param {?=} reportProgress
     * @return {?}
     */
    MSGMClient1Service.prototype.sendMessage = /**
     * @param {?} X_Ia_Correlation_Id
     * @param {?} X_Ia_Subject
     * @param {?} X_Ia_Roles
     * @param {?} MessageCreateRequest1
     * @param {?=} observe
     * @param {?=} reportProgress
     * @return {?}
     */
    function (X_Ia_Correlation_Id, X_Ia_Subject, X_Ia_Roles, MessageCreateRequest1, observe, reportProgress) {
        if (observe === void 0) { observe = 'body'; }
        if (reportProgress === void 0) { reportProgress = false; }
        if (X_Ia_Correlation_Id === null || X_Ia_Correlation_Id === undefined) {
            throw new Error('Required parameter X_Ia_Correlation_Id was null or undefined when calling sendMessage.');
        }
        if (X_Ia_Subject === null || X_Ia_Subject === undefined) {
            throw new Error('Required parameter X_Ia_Subject was null or undefined when calling sendMessage.');
        }
        if (X_Ia_Roles === null || X_Ia_Roles === undefined) {
            throw new Error('Required parameter X_Ia_Roles was null or undefined when calling sendMessage.');
        }
        if (MessageCreateRequest1 === null || MessageCreateRequest1 === undefined) {
            throw new Error('Required parameter MessageCreateRequest1 was null or undefined when calling sendMessage.');
        }
        /** @type {?} */
        var headers = this.defaultHeaders;
        if (X_Ia_Correlation_Id !== undefined && X_Ia_Correlation_Id !== null) {
            headers = headers.set('X-Ia-Correlation-Id', String(X_Ia_Correlation_Id));
        }
        if (X_Ia_Subject !== undefined && X_Ia_Subject !== null) {
            headers = headers.set('X-Ia-Subject', String(X_Ia_Subject));
        }
        if (X_Ia_Roles !== undefined && X_Ia_Roles !== null) {
            headers = headers.set('X-Ia-Roles', String(X_Ia_Roles));
        }
        // authentication (AuthorizationHeader) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }
        // to determine the Accept header
        /** @type {?} */
        var httpHeaderAccepts = [
            'application/json'
        ];
        /** @type {?} */
        var httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        /** @type {?} */
        var consumes = [
            'application/json'
        ];
        /** @type {?} */
        var httpContentTypeSelected = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }
        return this.httpClient.post(this.basePath + "/message/create", MessageCreateRequest1, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress
        });
    };
    MSGMClient1Service.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    MSGMClient1Service.ctorParameters = function () { return [
        { type: HttpClient },
        { type: String, decorators: [{ type: Optional }, { type: Inject, args: [BASE_PATH,] }] },
        { type: Configuration, decorators: [{ type: Optional }] }
    ]; };
    return MSGMClient1Service;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/msgm_angular-client/api/mSGMPublic1.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var MSGMPublic1Service = /** @class */ (function () {
    function MSGMPublic1Service(httpClient, basePath, configuration) {
        this.httpClient = httpClient;
        this.basePath = 'https://igate.beook.work/msgm/v1';
        this.defaultHeaders = new HttpHeaders();
        this.configuration = new Configuration();
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }
    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    /**
     * @private
     * @param {?} consumes string[] mime-types
     * @return {?} true: consumes contains 'multipart/form-data', false: otherwise
     */
    MSGMPublic1Service.prototype.canConsumeForm = /**
     * @private
     * @param {?} consumes string[] mime-types
     * @return {?} true: consumes contains 'multipart/form-data', false: otherwise
     */
    function (consumes) {
        var e_1, _a;
        /** @type {?} */
        var form = 'multipart/form-data';
        try {
            for (var consumes_1 = __values(consumes), consumes_1_1 = consumes_1.next(); !consumes_1_1.done; consumes_1_1 = consumes_1.next()) {
                var consume = consumes_1_1.value;
                if (form === consume) {
                    return true;
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (consumes_1_1 && !consumes_1_1.done && (_a = consumes_1.return)) _a.call(consumes_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return false;
    };
    /**
     * @param {?=} observe
     * @param {?=} reportProgress
     * @return {?}
     */
    MSGMPublic1Service.prototype.ping = /**
     * @param {?=} observe
     * @param {?=} reportProgress
     * @return {?}
     */
    function (observe, reportProgress) {
        if (observe === void 0) { observe = 'body'; }
        if (reportProgress === void 0) { reportProgress = false; }
        /** @type {?} */
        var headers = this.defaultHeaders;
        // to determine the Accept header
        /** @type {?} */
        var httpHeaderAccepts = [];
        /** @type {?} */
        var httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        return this.httpClient.get(this.basePath + "/ping", {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress
        });
    };
    MSGMPublic1Service.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    MSGMPublic1Service.ctorParameters = function () { return [
        { type: HttpClient },
        { type: String, decorators: [{ type: Optional }, { type: Inject, args: [BASE_PATH,] }] },
        { type: Configuration, decorators: [{ type: Optional }] }
    ]; };
    return MSGMPublic1Service;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/msgm_angular-client/api/api.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var APIS = [MSGMClient1Service, MSGMPublic1Service];

/**
 * @fileoverview added by tsickle
 * Generated from: lib/msgm_angular-client/model/collectionFilterDTO1.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/msgm_angular-client/model/dateTimeIntervalDTO1.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/msgm_angular-client/model/deliveryCollectionDTO1.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/msgm_angular-client/model/destinationCollectionDTO1.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/msgm_angular-client/model/destinationCreateDTO1.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
// WARNING: interface has both a type and a value, skipping emit
var DestinationCreateDTO1;
(function (DestinationCreateDTO1) {
    DestinationCreateDTO1.JoinPolicyEnum = {
        PUBLIC: (/** @type {?} */ ('PUBLIC')),
        PRIVATE: (/** @type {?} */ ('PRIVATE')),
        PROPERTY: (/** @type {?} */ ('PROPERTY'))
    };
    DestinationCreateDTO1.DestTypeEnum = {
        QUEUE: (/** @type {?} */ ('QUEUE')),
        TOPIC: (/** @type {?} */ ('TOPIC'))
    };
})(DestinationCreateDTO1 || (DestinationCreateDTO1 = {}));

/**
 * @fileoverview added by tsickle
 * Generated from: lib/msgm_angular-client/model/destinationCreateDetail1.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/msgm_angular-client/model/destinationCreateDetailDTO1.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/msgm_angular-client/model/destinationCreateRequest1.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/msgm_angular-client/model/destinationCreateResponse1.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/msgm_angular-client/model/destinationDTO1.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/msgm_angular-client/model/destinationDiscoverDTO1.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/msgm_angular-client/model/destinationDiscoverDTO1DomainAndAlias.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/msgm_angular-client/model/destinationDiscoverDTO1OwnerAndName.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/msgm_angular-client/model/destinationDiscoverDTO1Uid.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/msgm_angular-client/model/destinationDiscoverDetail1.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/msgm_angular-client/model/destinationDiscoverDetailDTO1.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * ioneaccess Message Broker Management (MSGM) API
 * API for ioneaccess Message Broker Management (MSGM)
 *
 * OpenAPI spec version: 1.0.0
 * Contact: kenzo.grieco@ionesoft.ch
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
// WARNING: interface has both a type and a value, skipping emit
var DestinationDiscoverDetailDTO1;
(function (DestinationDiscoverDetailDTO1) {
    DestinationDiscoverDetailDTO1.JoinPolicyEnum = {
        Empty: (/** @type {?} */ ('')),
        PUBLIC: (/** @type {?} */ ('PUBLIC')),
        PRIVATE: (/** @type {?} */ ('PRIVATE')),
        PROPERTY: (/** @type {?} */ ('PROPERTY'))
    };
    DestinationDiscoverDetailDTO1.DestTypeEnum = {
        Empty: (/** @type {?} */ ('')),
        QUEUE: (/** @type {?} */ ('QUEUE')),
        TOPIC: (/** @type {?} */ ('TOPIC'))
    };
})(DestinationDiscoverDetailDTO1 || (DestinationDiscoverDetailDTO1 = {}));

/**
 * @fileoverview added by tsickle
 * Generated from: lib/msgm_angular-client/model/destinationDiscoverRequest1.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/msgm_angular-client/model/destinationDiscoverResponse1.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/msgm_angular-client/model/destinationGetDTO1.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/msgm_angular-client/model/destinationGetDetail1.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/msgm_angular-client/model/destinationGetDetailDTO1.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/msgm_angular-client/model/destinationGetRequest1.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/msgm_angular-client/model/destinationGetResponse1.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/msgm_angular-client/model/destinationJoinDetailDTO1.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * ioneaccess Message Broker Management (MSGM) API
 * API for ioneaccess Message Broker Management (MSGM)
 *
 * OpenAPI spec version: 1.0.0
 * Contact: kenzo.grieco@ionesoft.ch
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
// WARNING: interface has both a type and a value, skipping emit
var DestinationJoinDetailDTO1;
(function (DestinationJoinDetailDTO1) {
    DestinationJoinDetailDTO1.StateEnum = {
        PENDING: (/** @type {?} */ ('PENDING')),
        ALLOWED: (/** @type {?} */ ('ALLOWED')),
        BANNED: (/** @type {?} */ ('BANNED'))
    };
    DestinationJoinDetailDTO1.PermissionsEnum = {
        READ: (/** @type {?} */ ('READ')),
        WRITE: (/** @type {?} */ ('WRITE')),
        READWRITE: (/** @type {?} */ ('READWRITE'))
    };
})(DestinationJoinDetailDTO1 || (DestinationJoinDetailDTO1 = {}));

/**
 * @fileoverview added by tsickle
 * Generated from: lib/msgm_angular-client/model/destinationListDTO1.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/msgm_angular-client/model/destinationListDetail1.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/msgm_angular-client/model/destinationListDetailDTO1.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/msgm_angular-client/model/destinationListRequest1.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/msgm_angular-client/model/destinationListResponse1.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/msgm_angular-client/model/destinationMemberCollectionDTO1.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/msgm_angular-client/model/destinationMemberDTO1.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/msgm_angular-client/model/detailResultResponse1.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/msgm_angular-client/model/detailResultResponse12.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/msgm_angular-client/model/globalResultResponse1.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/msgm_angular-client/model/globalResultResponse12.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/msgm_angular-client/model/identityDTO1.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/msgm_angular-client/model/messageCollectionDTO1.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/msgm_angular-client/model/messageCreateDTO1.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
// WARNING: interface has both a type and a value, skipping emit
var MessageCreateDTO1;
(function (MessageCreateDTO1) {
    MessageCreateDTO1.DeliveryPolicyEnum = {
        STATIC: (/** @type {?} */ ('STATIC')),
        DYNAMIC: (/** @type {?} */ ('DYNAMIC'))
    };
})(MessageCreateDTO1 || (MessageCreateDTO1 = {}));

/**
 * @fileoverview added by tsickle
 * Generated from: lib/msgm_angular-client/model/messageCreateDetail1.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/msgm_angular-client/model/messageCreateDetailDTO1.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/msgm_angular-client/model/messageCreateRequest1.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/msgm_angular-client/model/messageCreateResponse1.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/msgm_angular-client/model/messageDTO1.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/msgm_angular-client/model/messageDeleteDTO1.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/msgm_angular-client/model/messageDeleteDetail1.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/msgm_angular-client/model/messageDeleteDetailDTO1.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/msgm_angular-client/model/messageDeleteRequest1.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/msgm_angular-client/model/messageDeleteResponse1.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/msgm_angular-client/model/messageDeliveryCollectionDTO1.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/msgm_angular-client/model/messageDeliveryCollectionDTO1Collection.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/msgm_angular-client/model/messageDeliveryDTO1.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
// WARNING: interface has both a type and a value, skipping emit
var MessageDeliveryDTO1;
(function (MessageDeliveryDTO1) {
    MessageDeliveryDTO1.DeliveryStateEnum = {
        OK: (/** @type {?} */ ('OK')),
        WARNING: (/** @type {?} */ ('WARNING')),
        ERROR: (/** @type {?} */ ('ERROR'))
    };
})(MessageDeliveryDTO1 || (MessageDeliveryDTO1 = {}));

/**
 * @fileoverview added by tsickle
 * Generated from: lib/msgm_angular-client/model/messageEditDTO1.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/msgm_angular-client/model/messageEditDTO1NewMessage.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/msgm_angular-client/model/messageEditDetail1.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/msgm_angular-client/model/messageEditDetailDTO1.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/msgm_angular-client/model/messageEditRequest1.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/msgm_angular-client/model/messageEditResponse1.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/msgm_angular-client/model/messageGetDTO1.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/msgm_angular-client/model/messageGetDetail1.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/msgm_angular-client/model/messageGetDetailDTO1.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/msgm_angular-client/model/messageGetDetailDTO1Message.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/msgm_angular-client/model/messageGetRequest1.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/msgm_angular-client/model/messageGetResponse1.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/msgm_angular-client/model/messageListDTO1.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/msgm_angular-client/model/messageListDTO1FilterBy.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/msgm_angular-client/model/messageListDetail1.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/msgm_angular-client/model/messageListDetailDTO1.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/msgm_angular-client/model/messageListRequest1.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/msgm_angular-client/model/messageListResponse1.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/msgm_angular-client/model/timeStatsDTO1.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/msgm_angular-client/model/userCreateDTO1.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/msgm_angular-client/model/userCreateDetail1.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/msgm_angular-client/model/userCreateDetailDTO1.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/msgm_angular-client/model/userCreateRequest1.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/msgm_angular-client/model/userCreateResponse1.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/msgm_angular-client/model/userGetDTO1.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/msgm_angular-client/model/userGetDetail1.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/msgm_angular-client/model/userGetDetailDTO1.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/msgm_angular-client/model/userGetRequest1.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/msgm_angular-client/model/userGetResponse1.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/msgm_angular-client/model/models.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/msgm_angular-client/api.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ApiModule = /** @class */ (function () {
    function ApiModule(parentModule, http) {
        if (parentModule) {
            throw new Error('ApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
                'See also https://github.com/angular/angular/issues/20575');
        }
    }
    /**
     * @param {?} configurationFactory
     * @return {?}
     */
    ApiModule.forRoot = /**
     * @param {?} configurationFactory
     * @return {?}
     */
    function (configurationFactory) {
        return {
            ngModule: ApiModule,
            providers: [{ provide: Configuration, useFactory: configurationFactory }]
        };
    };
    ApiModule.decorators = [
        { type: NgModule, args: [{
                    imports: [],
                    declarations: [],
                    exports: [],
                    providers: [
                        MSGMClient1Service,
                        MSGMPublic1Service
                    ]
                },] }
    ];
    /** @nocollapse */
    ApiModule.ctorParameters = function () { return [
        { type: ApiModule, decorators: [{ type: Optional }, { type: SkipSelf }] },
        { type: HttpClient, decorators: [{ type: Optional }] }
    ]; };
    return ApiModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/msgm_angular-client/index.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/msgm-api-lib.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var MsgmApiLibService = /** @class */ (function () {
    function MsgmApiLibService(msgmConfigruationProvider, httpClient) {
        this.msgmConfigruationProvider = msgmConfigruationProvider;
        this.httpClient = httpClient;
        /** @type {?} */
        var config = new Configuration({
            basePath: msgmConfigruationProvider.config.apiConfig.basePathMsgm,
            apiKeys: {
                Authorization: this._loadAuthorization()
            }
        });
        this.msgmClientApiRefence = new MSGMClient1Service(httpClient, msgmConfigruationProvider.config.apiConfig.basePathMsgm, config);
    }
    /**
     * @return {?}
     */
    MsgmApiLibService.prototype.getMsgmClientApi = /**
     * @return {?}
     */
    function () {
        return this.msgmClientApiRefence;
    };
    /**
     * @private
     * @return {?}
     */
    MsgmApiLibService.prototype._loadAuthorization = /**
     * @private
     * @return {?}
     */
    function () {
        /** @type {?} */
        var accessToken = sessionStorage.getItem(this.msgmConfigruationProvider.config.apiConfig.authorizationSessionStorageKey);
        return typeof accessToken !== 'undefined' ? accessToken : '';
    };
    MsgmApiLibService.decorators = [
        { type: Injectable, args: [{
                    providedIn: 'root'
                },] }
    ];
    /** @nocollapse */
    MsgmApiLibService.ctorParameters = function () { return [
        { type: MsgmConfigurationProvider },
        { type: HttpClient }
    ]; };
    /** @nocollapse */ MsgmApiLibService.ngInjectableDef = defineInjectable({ factory: function MsgmApiLibService_Factory() { return new MsgmApiLibService(inject(MsgmConfigurationProvider), inject(HttpClient)); }, token: MsgmApiLibService, providedIn: "root" });
    return MsgmApiLibService;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/msgm-api-lib.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var MsgmApiLibComponent = /** @class */ (function () {
    function MsgmApiLibComponent() {
    }
    /**
     * @return {?}
     */
    MsgmApiLibComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
    };
    MsgmApiLibComponent.decorators = [
        { type: Component, args: [{
                    selector: 'lib-msgm-api-lib',
                    template: "\n    <p>\n      msgm-api-lib works!\n    </p>\n  "
                }] }
    ];
    /** @nocollapse */
    MsgmApiLibComponent.ctorParameters = function () { return []; };
    return MsgmApiLibComponent;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/msgm-api-lib.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @return {?}
 */
function MsgmConfigFactory() {
    /** @type {?} */
    var params = {};
    return new Configuration(params);
}
var MsgmApiLibModule = /** @class */ (function () {
    function MsgmApiLibModule() {
    }
    /**
     * @param {?=} msgmConfiguration
     * @return {?}
     */
    MsgmApiLibModule.forRoot = /**
     * @param {?=} msgmConfiguration
     * @return {?}
     */
    function (msgmConfiguration) {
        if (msgmConfiguration === void 0) { msgmConfiguration = {}; }
        return {
            ngModule: MsgmApiLibModule,
            providers: [
                msgmConfiguration.config || {
                    provide: MsgmConfigurationProvider,
                    useClass: DefaultMsgmConfiguration
                }
            ]
        };
    };
    MsgmApiLibModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [MsgmApiLibComponent],
                    imports: [
                        ApiModule.forRoot(MsgmConfigFactory)
                    ],
                    exports: [MsgmApiLibComponent]
                },] }
    ];
    return MsgmApiLibModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: public-api.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: msgm-api-lib.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { MsgmLibConfiguration, MsgmConfigurationProvider, DefaultMsgmConfiguration, MsgmConfiguration, MsgmApiLibService, MsgmApiLibComponent, MsgmConfigFactory, MsgmApiLibModule, APIS, MSGMClient1Service, MSGMPublic1Service, DestinationCreateDTO1, DestinationDiscoverDetailDTO1, DestinationJoinDetailDTO1, MessageCreateDTO1, MessageDeliveryDTO1, BASE_PATH, COLLECTION_FORMATS, Configuration, ApiModule, ApiModule as ɵa };

//# sourceMappingURL=msgm-api-lib.js.map